<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <div class="specific-box">
        <div class="steps-desc">
          <div class="steps-desc-left">
            <img src="~@/assets/quto-left.png" alt="">
          </div>
          <div class="steps-desc-center">情况一：添加投资者时，投资者信息表问卷第二题选择“是”特定对象确认流程如下：</div>
          <div class="steps-desc-right">
            <img src="~@/assets/quto-right.png" alt="">
          </div>
        </div>
        <div class="steps-item" v-for="(item, index) in itemsY" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-content" v-html="item.content"></div>
        </div>
      </div>
      <div class="specific-box">
        <div class="steps-desc">
          <div class="steps-desc-left">
            <img src="~@/assets/quto-left.png" alt="">
          </div>
          <div class="steps-desc-center">情况二：添加投资者时，投资者信息表问卷第二题选择“否”特定对象确认流程如下：</div>
          <div class="steps-desc-right">
            <img src="~@/assets/quto-right.png" alt="">
          </div>
        </div>
        <div class="steps-item" v-for="(item, index) in itemsN" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-content" v-html="item.content"></div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemsY: [
        {
          title: '1、身份认证',
          content: '投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别',
        },
        {
          title: '2、网络服务协议确认',
          content: '投资者对网络服务协议确认',
        },
        {
          title: '3、投资者信息及合格投资者承诺函确认',
          content: '投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认',
        },
        {
          title: '4、数字证书申请表上传',
          content: '投资者上传签署盖章的数字证书申请表',
        },
        {
          title: '5、等待管理人审核',
          content: '风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料',
        },
      ],
      itemsN: [
        {
          title: '1、身份认证',
          content: '投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别',
        },
        {
          title: '2、网络服务协议确认',
          content: '投资者对网络服务协议确认',
        },
        {
          title: '3、投资者信息确认',
          content: '投资者对投资者信息表、投资者资料进行确认',
        },
        {
          title: '4、数字证书申请表上传',
          content: '投资者上传签署盖章的数字证书申请表',
        },
        {
          title: '5、等待管理人审核',
          content: '风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.specific-box {
  background: #fff;
  overflow:hidden;
  margin: 15px;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
  border-radius: 2px;
  .steps-desc {
    margin: 15px;
    color: #999;
    background: rgb(252, 229, 193);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 15px 5px;
    font-size: 12px;
    align-content: center;
    .steps-desc-left,.steps-desc-right {
      img {
        width: 15px;
      }
    }
    .steps-desc-center {
      flex: .9;
    }
  }
  .steps-item {
    padding: 15px;
    border-bottom: 1px dashed #ccc;
    &:last-child {
      border-bottom: none;
    }
    &:first-child {
      border-bottom: none;
    }
    .item-title {
      font-size: 13px;
      color: #222222;
      margin-bottom: 10px;
    }
    .item-content {
      font-size: 13px;
      color: #999999;
    }
  }
}
</style>
